var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-overlay',{attrs:{"value":_vm.show,"opacity":"0.99"}},[_c('div',{staticClass:"text-center"},[_c('div',[_c('v-icon',{attrs:{"large":""}},[_vm._v("mdi-lan-disconnect")]),_vm._v(" "+_vm._s(_vm.t("No internet connection!"))+" ")],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }